/**
 * DetailsCard Component
 *
 * Form card for editing name and description fields of an asset or liability.
 *
 * Props:
 *   - item: The asset/liability object
 *   - isAsset: Boolean indicating if this is an asset (for placeholder text)
 *   - validationError: Error element to display for name field
 *   - onFieldChange: Function(field, value) to update a field
 */

const DetailsCard = ({ item, isAsset, isLiability, validationError, onFieldChange }) => {


var placeholder
if(isAsset) { placeholder = "'Personal pension'" }
if (isLiability) { placeholder = "'Credit card'" }


  return (
    <div className="card">


<div className="flex row medium-gap center space">
        <p className="regular">Details</p>  {validationError}
      </div>


      <div className="form-group margin-top-medium">
        <div className="form-item">
          <label htmlFor="name">Name</label>
          <input
            type="text"
            id="name"
            value={item.name}
            className="medium"
            placeholder={placeholder}
            onChange={(e) => onFieldChange("name", e.target.value)}
          />
        </div>
        <div className="form-item">
          <label htmlFor="description">Description</label>
          <input
            type="text"
            id="description"
            value={item.description}
            className="medium truncate-1"
            placeholder="(Optional)"
            onChange={(e) => onFieldChange("description", e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default DetailsCard;
